import request from '../utils/request_no_error'

export function fetchSetting() {
  return request({
    url: '/setting'
  })
}



// WEBPACK FOOTER //
// ./src/api/setting.js